/*
Controller: Conversionrates

Operations:
  getConversionRates
*/
var Api = require('../config')

var Conversionrates = (function () {
  /*
  Operation: getConversionRates
  Get current currency conversion rates
  Parameters:
  Responses:
    HTTP 200: ConversionRates object
    HTTP 504: The request could not be fulfilled because a required service wasn&#39;t available
  */
  function getConversionRatesConversionrates () {
    return new Promise(function (resolve, reject) {
      try {
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var path = '/conversionrates'
      Api
        .request({
          url: path,
          method: 'get'
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['getConversionRates'] = getConversionRatesConversionrates
  return ret
})()

module.exports = Conversionrates
